import { flyInVariantsDashboard } from '@/constant/common'
import { Site } from '@/types/siteLocation'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { motion } from 'framer-motion'
import { FC } from 'react'
import SitesAndLocationTableRow from './SitesAndLocationTableRow'

interface SitesAndLocationTableProps {
  rows: Site[]
  onEditSiteItem: (id: string, name: string) => void
  onEditLocationItem: (id: string, name: string, siteId: string) => void
}

const SitesAndLocationTable: FC<SitesAndLocationTableProps> = ({
  rows,
  onEditSiteItem,
  onEditLocationItem,
}) => {
  const MotionDiv = motion.div
  const handleEditSiteItem = (id: string, name: string) => {
    onEditSiteItem(id, name)
  }
  const handleEditLocationItem = (id: string, name: string, siteId: string) => {
    onEditLocationItem(id, name, siteId)
  }

  return (
    <Stack flexGrow="1">
      <MotionDiv
        initial="initial"
        animate="animate"
        variants={flyInVariantsDashboard}
      >
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            backgroundColor: 'common.white',
            border: '1px solid #D7D7D7',
            borderRadius: '3px',
          }}
        >
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead
              sx={{
                backgroundColor: '#EFEFEF',
                borderBottom: '1px solid #D7D7D7',
              }}
            >
              <TableRow>
                <TableCell width="47px" />
                <TableCell
                  sx={{
                    width: '379.25px',
                    borderRight: '1px solid #D7D7D7',
                  }}
                >
                  Site & Location Name
                </TableCell>
                <TableCell
                  sx={{
                    width: '339.25px',
                    borderRight: '1px solid #D7D7D7',
                  }}
                >
                  Number of Level
                </TableCell>
                <TableCell
                  sx={{
                    width: '339.25px',
                    borderRight: '1px solid #D7D7D7',
                  }}
                >
                  Number of Decoder
                </TableCell>
                <TableCell
                  sx={{
                    width: '339.25px',
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: 'common.white' }}>
              {rows.map((row, index) => (
                <SitesAndLocationTableRow
                  key={row.id}
                  row={row}
                  onEditSiteItem={handleEditSiteItem}
                  onEditLocationItem={handleEditLocationItem}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </MotionDiv>
      {/* <Stack sx={{ display: "flex", bottom: "0", justifyContent: "end", flexGrow: "1" }}>
        <TableFooter />
      </Stack> */}
    </Stack>
  )
}

export default SitesAndLocationTable
